import { FaSearch as SearchIcon } from 'react-icons/fa';

export default SearchIcon;
